module.exports = __webpack_public_path__ + "img/iosTip.22273456.webp";